import React, { useEffect, useState } from "react";
import intl from "react-intl-universal";
import styled from "styled-components";

import overviewRest from "../../../../../../rest/overviewRest";

import { Dialog } from "../../../../../containers/Dialog";
import { Progress } from "../../../../../components/Progress";
import { DialogBody } from "../../../../../containers/DialogBody";

const VerticalViewStyle = styled.div`
    min-height: 180px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const ImageStyle = styled.img`
    max-width: 800px;
    height: auto;
`;

export const VerticalViewDialog = props => {
    const { calculationId, view } = props;

    const [image, setImage] = useState();

    useEffect(() => {
        if (calculationId) {
            (async () => {
                let imageBase64;
                if (view === "SOUTH_NORD") {
                    imageBase64 = await overviewRest.getSouthNordViewImage(calculationId);
                } else if (view === "EAST_WEST") {
                    imageBase64 = await overviewRest.getEastWestViewImage(calculationId);
                }
                setImage(imageBase64);
            })();
        }
    }, [calculationId, view]);

    return (
        <Dialog
            width="860px"
            title={intl.get("enum.view." + view)}
            onClose={() => props.onClose()}>
            <DialogBody>
                <VerticalViewStyle>
                    <Progress
                        loading={!image}
                        text={intl.get("entry.plan.overview.loadingImage")}>
                        <ImageStyle src={image} />
                    </Progress>
                </VerticalViewStyle>
            </DialogBody>
        </Dialog>
    );
};